<template>
  <div class="testimonial-banner">
    <div class="container">
      <div class="testimonial pt-4">
        <div id="testimonial" class="columns is-vcentered is-gapless pt-6 px-4" @mouseenter="stopTimer()" @mouseleave="startCycle()">
          <div class="column is-3">
            <figure class="image testimonial-image m-a">
              <img :src="testimonials[currentIndex].image" />
            </figure>
          </div>
          <div class="column is-6">
            <div class="columns is-multiline is-centered">
              <div class="column is-12 testimonial-title has-text-centered">
                <div class="py-6">
                  <p>{{ testimonials[currentIndex].name }}</p>
                  <p>{{ testimonials[currentIndex].role }}</p>
                </div>
                <div class="is-inline-flex has-text-centered">
                  <RatingStars :rating="testimonials[currentIndex].rating" />
                </div>
              </div>
              <div
                class="column is-12 testimonial-title bold has-text-centered mh-10"
              >
                "{{ testimonials[currentIndex].message }}"
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-gapless is-mobile is-centered my-6">
          <div
            class="column is-narrow is-mobile"
            v-for="(testimonial, index) in testimonials"
            :key="index"
          >
            <div class="change-testimonial" @click="changeIndex(index)">
              <TestimonialButton :id="`button${index}`" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RatingStars from "@/components/atoms/RatingStars.vue";
import TestimonialButton from "@/components/atoms/TestimonialButton.vue";
import Velocity from "velocity-animate";

export default {
  components: {
    RatingStars,
    TestimonialButton,
  },
  data() {
    return {
      testimonials: [
        {
          name: "Saj",
          role: "Gym User",
          message: "Perfect app to find a gym that's most suitable for you. ",
          rating: 5,
          image: require("@/assets/images/JPEG/testimonials/Saj.jpg"),
        },
        {
          name: "Sam",
          role: "Gym User",
          message:
            "This looks like a great resource for people always on the go!",
          rating: 5,
          image: require("@/assets/images/JPEG/testimonials/Sam.jpg"),
        },
        {
          name: "Leanna",
          role: "General Manager",
          message:
            "We have had many new members since signing up with MyGymChecker, it's so easy to use",
          rating: 5,
          image: require("@/assets/images/JPEG/testimonials/Leanne.jpg"),
        },
        {
          name: "Adam",
          role: "Body Builder",
          message:
            "I was always trying to find the right gym for me, thanks to MyGymChecker I was able to find exactly what I was looking for, all because of their unique gym filters.",
          rating: 5,
          image: require("@/assets/images/JPEG/testimonials/Adam.jpg"),
        },
        {
          name: "Abby",
          role: "No1 Gym Dodger",
          message:
            "Me and my friend love using MyGymChecker because it helps us find all the pool and spa facilities Haha",
          rating: 5,
          image: require("@/assets/images/JPEG/testimonials/Abby.jpg"),
        },
      ],
      currentIndex: 0,
      timer: undefined,
    };
  },
  watch: {
    currentIndex() {
      let button = document.getElementById(`button${this.currentIndex}`);
      button.style.background = "white"

      for (let i = 0; i < this.testimonials.length; i++) {
        if (i !== this.currentIndex) {
          let button2 = document.getElementById(`button${i}`);
          button2.style.background = "#00c5fd";
        }
      }
    },
  },
  methods: {
    async cycleGallery() {
      try {
        let testimonial = document.getElementById("testimonial");
        await Velocity(testimonial, { opacity: 0.0001 }, { duration: 500 });
        if (this.currentIndex < this.testimonials.length - 1) {
          this.currentIndex++;
        } else {
          this.currentIndex = 0;
        }
        await Velocity(testimonial, { opacity: 1 }, { duration: 500 });
      } catch (error) {
        console.log(error);
      }
    },
    startCycle() {
      this.timer = setInterval(this.cycleGallery, 5000);
    },
    async changeIndex(index) {
      try {
        clearInterval(this.timer);
        this.timer = undefined;
        if (index === this.currentIndex) return false;
        let testimonial = document.getElementById("testimonial");
        await Velocity(testimonial, { opacity: 0.0001 }, { duration: 500 });
        this.currentIndex = index;
        await Velocity(testimonial, { opacity: 1 }, { duration: 500 });

        this.timer = setInterval(this.cycleGallery, 5000);
      } catch (error) {
        console.log(error);
      }
    },
    highlighted(index) {
      if (index == this.current_index) {
        return true;
      } else {
        return false;
      }
    },
    viewNext() {
      clearInterval(this.timer);
      this.timer = undefined;
      this.cycleGallery();
      this.timer = setInterval(this.cycleGallery, 5000);
    },
    stopTimer(){
      if(this.timer){
        clearInterval(this.timer);
        this.timer = undefined;
      }
    },
  },
  mounted() {
    let initialButton = document.getElementById("button0");
    initialButton.style.background = "white";
    this.startCycle();
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = undefined;
  },
};
</script>

<style>

.testimonial-banner {
  width: 100vw;
  min-height: 60vh;
  background-color: #333333;
  overflow: auto;
  clip-path: polygon(
      100% 5%,
      82% 5%,
      24% 5%,
      18% 0%,
      0 0,
      0% 95%,
      76% 95%,
      82% 100%,
      100% 100%
    );
}

.testimonial-image {
  width: calc(200px + 3vw);
  height: calc(200px + 3vw);
  overflow: hidden;
  border-radius: 50%
}

.testimonial-title {
  color: white;
  font-size: calc(1rem + 0.5vw);
}

.mh-10 {
  min-height: 12rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.img-slider {
  overflow: hidden;
  position: relative;
  height: 200px;
  width: 400px;
}

.change-testimonial {
  display: fixed;
  right: 50%;
  bottom: 0;
}
</style>
